module.exports = __webpack_public_path__ + "img/settings/OnApp.1c6c0f.png";